// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__oN6sY","container":"Breadcrumb_container__IX7fd"};